import React, { useEffect, useState } from 'react';
import { useQuery } from "react-query";
import axios from "axios";
import tw from 'tailwind-styled-components';
import Navigation from '../components/Navigation';
import Product from '../components/Product';
import Banner from '../components/Banner/Banner';
import { useSelector, useDispatch } from "react-redux";
// import { Set_Cart_Modal_Open } from '../Redux/actions';
import Product2 from '../components/Product2';
import Text from '../components/TextHeadlines/Text';
import Text1 from '../components/TextHeadlines/Text1'
import Text2 from '../components/TextHeadlines/Text2'
import Text3 from '../components/TextHeadlines/Text3'
import Text4 from '../components/TextHeadlines/Text4'
import OfferBanner from '../components/Banner/OfferBanner'
import Navbar from '../components/Navbar';
// import Dashboard from '../components/Dashboard/Dashboard';
import Categories from '../components/Categories';
import LoginModal from '../Pages/User/Login';
import EmailLoginModal from '../components/EmailLoginModal';
import SignupModal from '../Pages/User/Register';
// import Cart from '../components/Cart';
import Config from '../Config';
import Carousel from '../components/Carousel';
import { useNavigate } from 'react-router-dom';

function Home() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state) => state.UserReducer.user);
    // const isCartModalOpen = useSelector((state) => state.CartReducer.isCartModalOpen);
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [isOTPLoginModalOpen, setIsOTPLoginModalOpen] = useState(false);
    const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);
    const [activeCategory, setActiveCategory] = useState(null); // null for 'All' category
    const isLoggedIn = !!user?.token;
    // console.log('isLogged in >> ', isLoggedIn);


    const fetchProduct = async (categoryId = null, page = 1, viewAll = false) => {
        const url = categoryId
            ? `${Config.apiUrl}/products?category_id=${categoryId}${viewAll ? '' : `&page=${page}`}`
            : `${Config.apiUrl}/products${viewAll ? '' : `?limit=15&page=${page}`}`;

        // return await axios.get(url, {
        //     headers: {
        //         // Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Mywicm9sZSI6ImJ1eWVyIiwiaWF0IjoxNzU3ODcxODM1LCJleHAiOjE3NTg0NzY2MzV9.7Po1jSRMkgGGpDnlBPhBc9Pg5UDBvpchSjOCNhyXgE4`,
        //         Authorization: `Bearer ${user.token}`,
        //     },
        // });
        return await axios.get(url);
    };

    // const { isLoading, error, data, refetch } = useQuery(
    //     ["fetchProducts", activeCategory],          // refetch when activeCategory changes
    //     () => fetchProduct(activeCategory),
    //     {
    //         //   enabled: !!user?.token,
    //     }
    // );

    // Fetch Page 1 Products
    const { data: dataP1, isLoading: isLoadingP1, error: errorP1 } = useQuery(
        ["fetchProducts", activeCategory, 1], // Include page number in query key
        () => fetchProduct(activeCategory, 1)
    );

    // Fetch Page 2 Products
    const { data: dataP2, isLoading: isLoadingP2, error: errorP2 } = useQuery(
        ["fetchProducts", activeCategory, 2],
        () => fetchProduct(activeCategory, 2)
    );

    // Fetch Page 3 Products
    const { data: dataP3, isLoading: isLoadingP3, error: errorP3 } = useQuery(
        ["fetchProducts", activeCategory, 3],
        () => fetchProduct(activeCategory, 3)
    );

    // Fetch Carousel Data
    const { data: carouselsData, isLoading: isCarouselLoading } = useQuery('fetchCarousels', async () => {
        const { data } = await axios.get(`${Config.apiUrl}/carousels`);
        // console.log('API Response for Carousels:', data);
        return data?.data || [];
    });

    // Listen for category changes from Navbar
    useEffect(() => {
        const handleCategoryChange = (event) => {
            const { categoryId } = event.detail;
            setActiveCategory(categoryId);
        };

        window.addEventListener('categoryChanged', handleCategoryChange);

        return () => {
            window.removeEventListener('categoryChanged', handleCategoryChange);
        };
    }, []);

    // Background image for Categories section
    const categoryBgImage = carouselsData?.find(c => c.id === 9)?.image_url || '';

    const fetchCategory = async () => {
        return await axios.get(`${Config.apiUrl}/categories`);
    };

    const { isLoading: catLoading, error: catError, data: categoryResponse } = useQuery(
        "fetchCategory",
        fetchCategory
    );

    // Fetch products under 1000
    const fetchProductsUnder1000 = async (viewAll = false) => {
        const limit = viewAll ? '' : 'limit=12&';
        return await axios.get(`${Config.apiUrl}/products/?${limit}max_price=1000&sort_order=DESC`);
    };

    const { isLoading: under1000Loading, error: under1000Error, data: under1000Data } = useQuery(
        "fetchProductsUnder1000",
        () => fetchProductsUnder1000(false)
    );

    // Fetch latest products for you
    const fetchLatestProducts = async (viewAll = false) => {
        const limit = viewAll ? '' : 'limit=8&';
        return await axios.get(`${Config.apiUrl}/products/?${limit}sort_order=DESC&sorted_by=created_at`);
    };

    const { isLoading: latestLoading, error: latestError, data: latestData } = useQuery(
        "fetchLatestProducts",
        () => fetchLatestProducts(false)
    );

    // Fetch trending in sneakers
    const fetchTrendingSneakers = async (viewAll = false) => {
        const limit = viewAll ? '' : 'limit=4&';
        return await axios.get(`${Config.apiUrl}/products/?${limit}sort_order=DESC&sorted_by=created_at`);
    };

    const { isLoading: sneakersLoading, error: sneakersError, data: sneakersData } = useQuery(
        "fetchTrendingSneakers",
        () => fetchTrendingSneakers(false)
    );

    // const productData = data?.data?.data?.products || [];
    const productDataPage1 = dataP1?.data?.data?.products || [];
    const productDataPage2 = dataP2?.data?.data?.products || [];
    const productDataPage3 = dataP3?.data?.data?.products || [];

    const under1000Products = under1000Data?.data?.data?.products || [];
    const latestProducts = latestData?.data?.data?.products || [];
    const sneakersProducts = sneakersData?.data?.data?.products || [];

    // Navigation functions for View All buttons
    const handleViewAllProducts = (section) => {
        navigate(`/products/${section}`, {
            state: {
                categoryId: activeCategory,
                sectionTitle: getSectionTitle(section)
            }
        });
    };

    const getSectionTitle = (section) => {
        switch (section) {
            case 'all-products':
                return 'All Products';
            case 'personalized-picks':
                return 'Personalized Picks';
            case 'new-arrivals':
                return 'New Arrivals';
            case 'latest':
                return 'Latest Products For You';
            case 'under1000':
                return 'Products Under ₹1000';
            case 'sneakers':
                return 'Trending in Sneakers';
            default:
                return 'Products';
        }
    };

    return (

        <MainContainer>
            {/* <Navigation categories={categoryData} /> */}
            {/* <Navigation categories={categoryResponse?.data?.data?.categories || []} /> */}
            <Navbar categories={categoryResponse?.data?.data?.categories || []} />

            <main>
                {/* <Dashboard /> */}
                <Carousel isLoading={isCarouselLoading} carousels={carouselsData} />
                <Product
                    products={productDataPage1}
                    onOpenLoginModal={() => setIsLoginModalOpen(true)}
                    // onOpenCartModal={() => dispatch(Set_Cart_Modal_Open(true))}
                />
                <ViewAll onClick={() => handleViewAllProducts('all-products')}>
                {/* <ViewAll onClick={() => navigate('/categories')}> */}
                    Explore All Products
                </ViewAll>

                {/* <OfferBanner /> */}
                <Banner />
                <Categories
                    categoriesData={categoryResponse?.data?.data?.categories || []}
                    bgImage={categoryBgImage}
                />
                {/* <Text /> */}
                <Text3/>
                <Product
                    products={productDataPage1}
                    onOpenLoginModal={() => setIsLoginModalOpen(true)}  // opens login modal if not logged in
                    // onOpenCartModal={() => dispatch(Set_Cart_Modal_Open(true))}  
                />
                <ViewAll onClick={() => handleViewAllProducts('personalized-picks')}>
                {/* <ViewAll onClick={() => navigate('/categories')}> */}
                    Explore All Products
                </ViewAll>
                <OfferBanner />

                <Text />

                <Product
                    products={productDataPage1}
                    onOpenLoginModal={() => setIsLoginModalOpen(true)}
                    // onOpenCartModal={() => dispatch(Set_Cart_Modal_Open(true))}
                />
                <ViewAll onClick={() => handleViewAllProducts('new-arrivals')}>
                {/* <ViewAll onClick={() => navigate('/categories')}> */}
                    Explore All Products
                </ViewAll>

                {/* Latest For You Section */}
                <Text1/>

                <Product
                    products={latestProducts}
                    onOpenLoginModal={() => setIsLoginModalOpen(true)}
                    // onOpenCartModal={() => dispatch(Set_Cart_Modal_Open(true))}
                />
                <ViewAll onClick={() => handleViewAllProducts('latest')}>
                {/* <ViewAll onClick={() => navigate('/categories')}> */}
                    Explore All Products
                </ViewAll>

                {/* Products Under 1000 Section */}
                <Text2 />

                <Product
                    products={under1000Products}
                    onOpenLoginModal={() => setIsLoginModalOpen(true)}
                    // onOpenCartModal={() => dispatch(Set_Cart_Modal_Open(true))}
                />
                <ViewAll onClick={() => handleViewAllProducts('under1000')}>
                {/* <ViewAll onClick={() => navigate('/categories')}> */}
                    Explore All Products
                </ViewAll>


                {/* Trending in Sneakers Section */}
                <Text4 />

                <Product
                    products={sneakersProducts}
                    onOpenLoginModal={() => setIsLoginModalOpen(true)}
                    // onOpenCartModal={() => dispatch(Set_Cart_Modal_Open(true))}
                />
                <ViewAll onClick={() => handleViewAllProducts('sneakers')}>
                {/* <ViewAll onClick={() => navigate('/categories')}> */}
                    Explore All Products
                </ViewAll>

                {/* <FlatOffer /> */}

            </main>

            {/* Modals */}
            <EmailLoginModal
                isOpen={isLoginModalOpen}
                onClose={() => setIsLoginModalOpen(false)}
                onSwitchToSignup={() => {
                    setIsLoginModalOpen(false);
                    setIsSignupModalOpen(true);
                }}
                onSwitchToEmailLogin={() => {
                    setIsLoginModalOpen(false);
                    setIsOTPLoginModalOpen(true);
                }}
            />
            <LoginModal
                isOpen={isOTPLoginModalOpen}
                onClose={() => setIsOTPLoginModalOpen(false)}
                onSwitchToSignup={() => {
                    setIsOTPLoginModalOpen(false);
                    setIsSignupModalOpen(true);
                }}
            />
            <SignupModal
                isOpen={isSignupModalOpen}
                onClose={() => setIsSignupModalOpen(false)}
                onSwitchToLogin={() => {
                    setIsSignupModalOpen(false);
                    setIsLoginModalOpen(true);
                }}
            />
            {/* <Cart
                isOpen={isCartModalOpen}
                onClose={() => dispatch(Set_Cart_Modal_Open(false))}
            /> */}
        </MainContainer>
    );
}

// Styled Components
const MainContainer = tw.div`bg-white min-h-screen`;
const LoadingContainer = tw.div`flex justify-center items-center py-12`;
const LoadingSpinner = tw.div`animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600`;
const ErrorText = tw.p`text-center text-red-500`;
const ViewAll = tw.button`
  block mx-auto px-3 py-0.5 
  text-kuality-blue rounded-md 
  hover:text-kuality-dark transition-colors 
  text-md font-medium
`;


const HomeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6 text-gray-700"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
);
const ChevronDownIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 ml-1 text-gray-600"><path d="m6 9 6 6 6-6"></path></svg>
);
const SearchIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-gray-500"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
);
const UserIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6 text-gray-700"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
);
const ShoppingCartIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6 text-gray-700"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
);
const GridIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6"><rect width="18" height="18" x="3" y="3" rx="2" /><path d="M3 12h18M12 3v18" /></svg>
);
const CoffeeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6 text-gray-700"><path d="M10 2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2" /><path d="M17 5h.01" /><path d="M14 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V2" /><path d="M6 8v8a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4V8" /><path d="M18 12h2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2" /></svg>
);


export default Home;